import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

import styles from './VpTextLimit.module.less';

export const VpTextLimit = ({ value = ' ', limit = 100, ...rest }) => {
  const [hideText, setHideText] = useState(true);

  if (value?.length > limit) {
    return (
      <>
        {hideText ? value?.substring(0, limit) + '...' : value}
        <Typography
          variant="span"
          onClick={() => setHideText(!hideText)}
          className={styles.limitStyles}
          {...rest}
        >
          {hideText ? 'See More' : 'See Less'}
        </Typography>
      </>
    );
  }
  return value;
};

VpTextLimit.propTypes = {
  value: PropTypes.string,
  limit: PropTypes.number
};

export default VpTextLimit;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTextLimit/VpTextLimit.jsx